import React from 'react';
import AppState from 'js/stores/AppState';
import { Link } from '@reach/router';
import userCountry from 'js/services/UserCountry';

const WelcomeHeadline = ({ mseller, activationHandler }) => {

  return (
    <div className="container">
      <div className="welcome-tagline">
        { userCountry() === 'NG' ? (
          <>
            <h1>{mseller}, Welcome to your checkout</h1>
            <p>Sell 5X faster, hassle free</p>
          </>
        ) : (
          <>
            <h1>Welcome to your store</h1>
            <p>All you have to do is register - we’ve got the rest covered.</p>
          </>
        )}

        <Link to={'/login/'} className="btn btn-lg btn-pod btn-primary btn-activate-store" onClick={activationHandler}>
          { userCountry() === 'NG' && 'Activate your Checkout'}
          { userCountry() !== 'NG' && 'Activate your Store'}
        </Link>
      </div>
    </div>
  );
}

export default WelcomeHeadline;
